import React, { PropsWithChildren } from "react";
import { FormContextState } from "models/propTypes/genericFormProps";
import { FormReducer } from "./reducer";
import { ContextConstants } from "utils/constants";

const initialState: FormContextState = {
  autogeneratedValues: undefined,
  setAutogeneratedValues: (values: any) => {},
};

export const FormContext = React.createContext<FormContextState>(initialState);

const FormContextProvider: React.FC<PropsWithChildren> = (props) => {
  const [state, dispatch] = React.useReducer(FormReducer, initialState);

  const setAutogeneratedValues = (values: any) => {
    dispatch({ type: ContextConstants.FormActions.SET_AUTOGENERATED_VALUES, payload: values });
  };

  return (
    <FormContext.Provider
      value={{
        ...state,
        setAutogeneratedValues: setAutogeneratedValues,
      }}
    >
      {props.children}
    </FormContext.Provider>
  );
};

export default FormContextProvider;
